$('.accordionTabHeight').matchHeight()

var toggleContent = function ($this, activeTab) {
  $this
    .closest('.complex_accordion-container')
    .find('[data-tab-content="' + activeTab + '"]')
    .slideDown()
    .addClass('visible_content')
}

$('.complex_accordion').on('click', '.complex_accordion__item', function () {
  var $this = $(this)
  if ($this.hasClass('active')) {
    return false
  } else {
    $this
      .closest('.complex_accordion')
      .find('.complex_accordion__item')
      .removeClass('active')
      .find('p')
      .slideUp()
    $this
      .closest('.complex_accordion-container')
      .find(
        '.complex_accordion__content--hidden, .complex_accordion__bottom_part'
      )
      .fadeOut(400)
    var activeTab = $(this).data('tab')
    if ($this.closest('.complex_accordion').hasClass('opened')) {
      setTimeout(function () {
        $('.complex_accordion__content--hidden').removeClass('visible_content')
        $this
          .closest('.complex_accordion-container')
          .find('[data-tab-content="' + activeTab + '"]')
          .fadeIn()
          .addClass('visible_content')
      }, 401)
    } else {
      toggleContent($this, activeTab)
    }
    $this.addClass('active').closest('.complex_accordion').addClass('opened')
  }
})

$('.complex_accordion-container').on('click', '.close_content', function () {
  $(this)
    .closest('.complex_accordion-container')
    .find('.complex_accordion')
    .removeClass('opened')
    .find('.complex_accordion__item')
    .removeClass('active')
    .find('p')
    .slideDown()
  $(this).closest('.complex_accordion__content--hidden').slideUp()
  $(this)
    .closest('.complex_accordion-container')
    .find('.complex_accordion__bottom_part')
    .slideDown()
})

/*responsive click-scroll*/

if ($(window).width() <= 991) {
  $('.complex_accordion__item').on('click', function () {
    var $this = $(this),
      tab = $this.data('tab'),
      contentPosition = ''
    setTimeout(function () {
      if ($('.complex_accordion').hasClass('opened')) {
        contentPosition = $(
          '.complex_accordion__content--hidden.visible_content'
        ).offset().top
      } else {
        contentPosition = $this
          .closest('.complex_accordion-container')
          .find('[data-tab-content="' + tab + '"]')
          .offset().top
      }
      var HeaderHeight = $('.header').outerHeight()
      $('html, body').animate(
        {
          scrollTop: contentPosition - HeaderHeight,
        },
        1000
      )
    }, 400)
  })
}
